import { BonusCondition } from '../bonus-condition';
import { BonusConditionDto } from '../dto/bonus-condition-dto';

export const mapBonusCondition = (bonusCondition: BonusConditionDto): BonusCondition => ({
    id: bonusCondition.id,
    title: bonusCondition.title,
    description: bonusCondition.description,
    price: bonusCondition.price,
    quantity: bonusCondition.quantity,
    percentage: bonusCondition.percentage,
    mode: bonusCondition.mode,
    currency: bonusCondition.currency,
    unit: bonusCondition.unit,
    responsibleContactId: bonusCondition.responsibleContactId,
    conditionFrom: bonusCondition.conditionFrom && new Date(bonusCondition.conditionFrom),
    conditionTo: bonusCondition.conditionTo && new Date(bonusCondition.conditionTo),
});
